import {type KeyboardEvent} from 'react';
import {useConstCallback} from './useConstCallback';

/**
 * Execute callback when `Enter` is pressed
 * @param cb Callback
 * @example
 * ```tsx
 * const doThingOnEnter = useCallback(() => {...}, []);
 * const handleInputEnterKey = useHandleInputEnterKey(doThingOnEnter);
 * return (
 * 	<Input onKeyDown={handleInputEnterKey} />
 * );
 * ```
 */
export const useHandleInputEnterKey = (
	cb: (event: KeyboardEvent<HTMLInputElement>) => void,
) => {
	const handleInputEnterKey = useConstCallback(
		(event: React.KeyboardEvent<HTMLInputElement>) => {
			if (event.key !== 'Enter') return;
			cb(event);
		},
	);
	return handleInputEnterKey;
};

export default useHandleInputEnterKey;
